<template>
  <div v-loading="tableLoading">
    <el-table :data="obj.datalists" class="table">
      <el-table-column type="index" width="40"></el-table-column>
      <el-table-column
        label="素材ID"
        prop="recCode"
        width="140"
        class="font-bold"
      ></el-table-column>
      <el-table-column label="图片" width="100">
        <template slot-scope="scope">
          <!-- <img :src="scope.row.icon" alt  height="80px"/> -->
          <!-- <el-image
            style="margin-right: 10px;float: left;width: 60px;height: 60px;border-radius: 4px;"
            :src="scope.row.icon"
          >
            <div slot="error" class="image-slot">
              <img :src="scope.row.tempUrl" alt height="80px" />
            </div>
          </el-image> -->
        </template>
      </el-table-column>
      <el-table-column
        label="素材网站"
        prop="webType"
        width="120"
        class="font-bold"
      >
        <template slot-scope="scope">
          <p v-if="scope.row.webType == 'shutterstock'">spic</p>
          <p v-else>{{ scope.row.webType }}</p>
        </template>
      </el-table-column>
      <el-table-column
        label="格式"
        prop="formatName"
        width="60"
        class="font-bold"
      ></el-table-column>
      <el-table-column label="下载费用" width="100">
        <template slot-scope="scope">
          <p v-if="scope.row.orderType == 1">免费下载</p>
          <p v-else>扣除：1次</p>
        </template>
      </el-table-column>
      <el-table-column
        label="下载时间"
        prop="buyTime"
        class="font-gray"
      ></el-table-column>
      <el-table-column label="操作状态" width="240">
        <template slot-scope="scope">
          <div v-if="scope.row.orderType == 1">
            <!-- 有下载链接时显示点击下载按钮 -->
            <div v-if="scope.row.downurl">
              <a rel="nofollow" :href="scope.row.downurl" target="_blank"
                ><el-button type="primary" size="small">点击下载</el-button></a
              >
              <a rel="nofollow" :href="scope.row.downurl2" target="_blank"
                ><el-button type="info" size="small" style="margin-left:10px;"
                  >备用下载</el-button
                ></a
              >
            </div>
            <!-- 没有下载链接时显示免费下载按钮 -->
            <el-button
              v-else
              type="danger"
              size="small"
              @click="handleFreeDownload(scope.row, scope.$index)"
              >免费下载</el-button
            >
          </div>
          <div v-else>
            <a rel="nofollow" :href="scope.row.downurl" target="_blank"
              ><el-button type="primary" size="small">点击下载</el-button></a
            >
            <a rel="nofollow" :href="scope.row.downurl2" target="_blank"
              ><el-button type="info" size="small" style="margin-left:10px;"
                >备用下载</el-button
              ></a
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="obj.total"
      v-if="obj.total > 10"
    ></el-pagination>
  </div>
</template>

<script>
import { reDownload } from "../../../api/downLoad";
export default {
  props: {
    obj: {
      type: Object,
    },
    // 带有默认值的对象
    data: {
      type: Array,
    },
  },
  computed: {
    tableData() {
      return this.data;
    },
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      tableLoading: false,
    };
  },
  methods: {
    // 免费下载：获取下载链接但不自动打开
    handleFreeDownload(item, index) {
      this.tableLoading = true;
      let buydata = {
        imageID: item.recCode,
        webType: item.webType,
        format: item.format,
      };
      reDownload(buydata)
        .then((result) => {
          this.tableLoading = false;
          // 更新数据，保存下载链接
          this.$set(this.obj.datalists[index], "downurl", result.downloadUrl);
          this.$set(this.obj.datalists[index], "downurl2", result.downloadUrl2);
        })
        .catch((error) => {
          this.tableLoading = false;
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.$emit("sizeChange", val);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.$emit("pageChange", val);
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped></style>
